export enum ParsingThemesEditorModes {
  edit = 0,
  create = 1,
  fromQuery = 2,
}
